<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-100">
            <div class="media">
              <img src="/static/img/blue_2@3x.png"/>
              <div class="media-body">
                <h1>{{classInfo.class_name}}</h1>
                <div><span class="gray">과목</span> {{classInfo.cate_code_name}}  ·  <span class="gray">클래스 인원 </span> <span class="number">{{classUserData.length}}</span>  · <span class="gray">담당선생님</span> {{classInfo.class_manager_name}}</div>
              </div>
            </div>
          </div>
          <div class="p-2 ml-auto button-group">
            <button type="button" class="btn mint" @click="modifyClass">수정</button>
            <!-- <button type="button" class="btn setting" @click="modifyClass"><i class="fa fa-ellipsis-h"></i></button> -->
            <!-- <button type="button" class="btn btn-danger" @click="deleteClass"><i class="fa fa-trash"></i> 삭제</button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="card second-card" v-if="classInfo.attend_yn === 'Y'">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-0">
            <h2>출석 현황</h2>
          </div>
          <div class="ml-auto p-0">
            <button type="button" class="btn btn-info" @click="goSettingAttendPage">출석일 설정</button>
            <button type="button" class="btn check mint" @click="goCheckAttendancePage">출석체크</button>
          </div>
        </div>
      </div>
      <el-row class="scheduleCheck">
        <el-col :span="4">
          <div>
            <h5 class="number">{{attendance.rate + '%'}}</h5>
            <p class="small gray">출석률</p>
            <h5 class="number">{{attendance.cnt}}</h5>
            <p class="small gray">출석인원</p>
            <p class="small gray">{{formatterDate(attendance.date)}}</p>
          </div>
        </el-col>
        <el-col :span="20">
          <bar-chart chart-id="scheduleBarChart" :chart-data="chartData" :height="chartHeight" :options="chartOptions"></bar-chart>
        </el-col>
      </el-row>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-0">
            <h2>클래스 인원 <span class="number mint">{{classUserData.length}}</span></h2>
          </div>
          <div class="ml-auto p-0">
            <button type="button" class="btn btn-primary addUser-middle" @click="addClassUser">+ 클래스 인원 등록하기</button>
          </div>
        </div>
      </div>
      <stone-data-table
        :loading="searchLoading"
        :columns="classUserColumns"
        :data="classUserData"
        :table-props="classUserProps"
        :page-size="emptyPageSize"
        :pagination-props="emptyPaginationProps"
        @row-click="classUserRowClickHandler">
      </stone-data-table>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-0">
            <h2>공지사항</h2>
          </div>
        </div>
      </div>
      <stone-data-table
        :loading="searchLoading"
        :columns="noticeColumns"
        :data="noticeData"
        :table-props="noticeProps"
        :page-size="emptyPageSize"
        :pagination-props="emptyPaginationProps"
        @row-click="noticeRowClickHandler">
      </stone-data-table>
    </div>

    <el-dialog title="클래스인원 선택" :visible.sync="dialogTableVisible" width="70%" :before-close="diallogClosedHandler">
      <el-row>
        <el-col :span="13">
          <h5>
            전체 인원 <strong><span class="number mint">{{classUserLeftData.length}}</span></strong>
          </h5>
          <el-input v-model="classUserLeftFilters[0].value" placeholder="클래스 / 이름 / 전화번호" prefix-icon="el-icon-search" class="user-filter"></el-input>
          <stone-data-table
            ref="classUserLeftTable"
            class="no-left-margin small-td"
            table-ref="classUserLeftTable"
            :loading="searchLoading"
            :columns="classUserPopupLeftColumns"
            :data="classUserLeftData"
            :filters="classUserLeftFilters"
            :table-props="classUserProps"
            :page-size="emptyPageSize"
            :pagination-props="emptyPaginationProps"
            @selection-change="handleSelectionChangeLeft"
            @row-click="classUserLefteRowClickHandler">
        </stone-data-table>
        <!-- <div class="text-right mt-3">
          <button type="button" class="btn white" @click="handleSelectionToggle('classUserLeftTable', false)">전체선택해제</button>
          <button type="button" class="btn white text-black" @click="handleSelectionToggle('classUserLeftTable', true)">전체선택</button>
        </div> -->
        </el-col>
        <el-col :span="2">
          <div class="align-middle member-transfer">
            <el-button icon="fas fa-arrow-right"  @click="moveRight" class="btn" :disabled="classUserLeftSelection.length === 0"></el-button>
            <el-button icon="fas fa-arrow-left"  @click="moveLeft" class="btn" :disabled="classUserRightSelection.length === 0"></el-button>
          </div>
        </el-col>
        <el-col :span="9">
          <h5>
            선택된 클래스 인원 <strong><span class="number mint">{{classUserRightData.length}}</span></strong>
          </h5>
          <el-input v-model="classUserRightFilters[0].value" placeholder="이름 / 전화번호" prefix-icon="el-icon-search" class="user-filter"></el-input>
          <stone-data-table
            ref="classUserRightTable"
            class="no-left-margin small-td"
            table-ref="classUserRightTable"
            :loading="searchLoading"
            :columns="classUserPopupColumns"
            :data="classUserRightData"
            :filters="classUserRightFilters"
            :table-props="classUserProps"
            :page-size="emptyPageSize"
            :pagination-props="emptyPaginationProps"
            @selection-change="handleSelectionChangeRight"
            @row-click="classUserRighteRowClickHandler">
        </stone-data-table>
        <!-- <div class="text-right mt-3">
          <button type="button" class="btn white" @click="handleSelectionToggle('classUserRightTable', false)">전체선택해제</button>
          <button type="button" class="btn white text-black" @click="handleSelectionToggle('classUserRightTable', true)">전체선택</button>
        </div> -->
        </el-col>
      </el-row>
      <div style="margin-top: 20px; text-align: right;">

        <el-button @click="diallogClosedHandler">닫기</el-button>
        <el-button type="primary" @click="registerClassUser">완료</el-button>
      </div>
    </el-dialog>
    <notice ref="notice"></notice>
  </div>
</template>

<script>

import common from '@/modules/common'
import BarChart from '@/components/chart/Bar.js'
import notice from '@/pages/components/Notice.vue'

export default {
  name: 'M020103',
  components: {BarChart, notice},
  mixins: [common.mixins],
  data () {
    return {
      isUse: true,
      isModify: true,
      dialogTableVisible: false,
      classInfo: {
        class_seq: 0,
        cate_code: '',
        cate_code_name: '',
        class_name: '',
        class_manager: '',
        class_manager_name: '',
        memo: '',
        use_yn: 'Y',
        attend_yn: 'N',
        class_user: []
      },
      attendance: {
        date: '',
        cnt: 0,
        rate: 0
      },
      noticeData: [],
      noticeColumns: [
        {label: '작성일', prop: 'reg_dt', align: 'center', width: 100},
        {label: '제목', prop: 'title', align: 'left', width: 300},
        {label: '공개', prop: 'open_yn_name', align: 'center', width: 100}
      ],
      paginationProps: {},
      noticeProps: {height: 200},
      classUserData: [],
      classUserColumns: [
        {label: 'No', align: 'center', type: 'index', fixedWidth: 100},
        {label: '이름', prop: 'user_name', align: 'center'},
        {label: '전화번호', prop: 'phone', align: 'center', formatter: this.columnFormatterPhone},
        {label: '학교', prop: 'school_name', align: 'left'},
        {label: '등록일', prop: 'reg_dt', align: 'center', formatter: this.columnFormatterDate}
      ],
      classUserProps: {height: 400},
      classUserPopupLeftColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection'},
        // {label: 'No', align: 'center', type: 'index', width: 40},
        {label: '클래스명', prop: 'class_name', align: 'left', width: 200},
        {label: '이름', prop: 'user_name', align: 'center', width: 80},
        {label: '전화번호', prop: 'phone', align: 'center', width: 100, formatter: this.columnFormatterPhone}
      ],
      classUserPopupColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection'},
        // {label: 'No', align: 'center', type: 'index', width: 40},
        {label: '이름', prop: 'user_name', align: 'center', width: 100},
        {label: '전화번호', prop: 'phone', align: 'center', width: 120, formatter: this.columnFormatterPhone}
      ],
      classUserLeftData: [],
      classUserRightData: [],
      classUserLeftSelection: [],
      classUserRightSelection: [],
      classUserLeftFilters: [
        {prop: ['class_name', 'user_name', 'phone'], value: ''}
      ],
      classUserRightFilters: [
        {prop: ['user_name', 'phone'], value: ''}
      ],
      chartData: [],
      chartHeight: 100,
      chartOptions: {
        layout: {
          padding: {left: 10, right: 10, top: 20, bottom: 10}
        },
        legend: {display: false},
        // gridLines: {offsetGridLines: false},
        scales: {
          yAxes: [
            {
              gridLines: {display: false},
              ticks: {min: 0, max: 100}
            }
          ],
          xAxes: [
            {ticks: {
              // fontFunction: function (index) { if (index % 2 !== 0) { return '14px' } else { return '30px' } },
              callback: function (value, index, values) { return value }},
            gridLines: {display: false},
            barThickness: 10
            }
          ]
        }
        // tooltips: {
        // callbacks: {
        //     title: function (tooltipItem, data) {
        //       return data['labels'][tooltipItem[0]['index']]
        //     },
        //     label: function (tooltipItem, data) {
        //       return data['datasets'][0]['data'][tooltipItem['index']]
        //     },
        //     afterLabel: function (tooltipItem, data) {
        //       var dataset = data['datasets'][0]
        //       return dataset['data'][tooltipItem['index']]
        //     }
        //   },
        //   backgroundColor: '#FFF',
        //   titleFontSize: 16,
        //   titleFontColor: '#0066ff',
        //   bodyFontColor: '#000',
        //   bodyFontSize: 14,
        //   displayColors: false
        // }
      }
    }
  },
  beforeCreate () {
    if (this.$route.params.class_seq === undefined || this.$route.params.class_seq === 0) {
      this.$router.push({name: 'M020101'})
    }
  },
  created () {
    this.retreiveNotice()
    this.loadInfo(this.$route.params.class_seq)
  },
  methods: {
    // 공지사항 조회
    retreiveNotice: function () {
      this.loadStoneDataTable('/board/notice/' + this.$route.params.class_seq, null, false)
        .then(response => {
          this.noticeData = response.data
        })
        .catch(() => {
        })
    },
    // 클래스 정보 조회
    loadInfo (classSeq) {
      this.loadStoneDataTable('/class/load/' + classSeq, null, false)
        .then(response => {
          const result = response.data
          // console.log(result)
          Object.keys(this.classInfo).forEach(key => {
            this.classInfo[key] = result.class[key]
          })
          this.classUserData = result.class_user
          this.isUse = result.class.use_yn === 'Y'
        })
      // 출석률
      common.axios.get('/class/attend/' + classSeq)
        .then(response => {
          const result = response.data
          if (result && result.length > 0) {
            this.chartData = this.getChartData(result)
            const len = result.length - 1
            this.attendance = {
              date: result[len].attendance_dt,
              cnt: result[len].attend_cnt,
              rate: result[len].attend_rate
            }
          }
        })
    },
    noticeRowClickHandler (row) {
      this.handleNoticeDiallogLoad(row.board_seq)
    },
    classUserRowClickHandler (row) {
    },
    // 클래스 인원 추가
    addClassUser () {
      this.dialogTableVisible = true
      this.classUserRightData = [].slice.call(this.classUserData)
      this.retreiveClassUserAdd(this.classInfo.class_seq)
    },
    // 현재 클래스에 속하지 않은 수강생 조회
    retreiveClassUserAdd () {
      this.loadStoneDataTable('/class/user/not/' + this.classInfo.class_seq, null, false)
        .then(response => {
          this.classUserLeftData = response.data
        })
        .catch(() => {
          this.classUserLeftData = []
        })
    },
    // 우측으로 선택된 수강생 이동
    moveRight () {
      this.classUserRightData = this.classUserRightData.concat(this.classUserLeftSelection)
      this.classUserLeftData = this.arraySplice(this.classUserLeftSelection, this.classUserLeftData)
      this.classUserLeftSelection = []
      this.classUserLeftFilters[0].value = ''
    },
    // 좌측으로 선택된 수강생 이동
    moveLeft () {
      this.classUserLeftData = this.classUserLeftData.concat(this.classUserRightSelection)
      this.classUserRightData = this.arraySplice(this.classUserRightSelection, this.classUserRightData)
      this.classUserRightSelection = []
      this.classUserRightFilters[0].value = ''
    },
    arraySplice (selection, target) {
      const deleteIndex = []
      selection.map(item => {
        deleteIndex.push(target.findIndex(e => e === item))
      })
      // 정렬 순서가 선택된 순서에 따라 틀려지므로, 마지막 인덱스부터 삭제 할 수 있도록 정렬(DESC)한다.
      deleteIndex.sort((a, b) => b - a).map(idx => {
        target.splice(idx, 1)
      })
      return target
    },
    handleSelectionChangeLeft (value) {
      this.classUserLeftSelection = value
    },
    handleSelectionChangeRight (value) {
      this.classUserRightSelection = value
    },
    // 클래스 인원 등록
    registerClassUser () {
      if (this.classUserRightData.length === 0) {
        this.$message.error('등록할 클래스 인원이 없습니다.')
        return
      }
      this.classInfo.class_user = this.classUserRightData
      // console.log(this.classInfo)
      this.$nextTick(() => {
        common.axios.post('/class/user', this.classInfo)
          .then(response => {
            if (response.data.status === 1) {
              this.$message('수정하였습니다.')
              this.dialogTableVisible = false
              this.classUserLeftData = []
              this.classUserRightData = []
              this.classInfo.class_user = []
              this.retreiveClassUser()
            }
          })
      })
    },
    // 현재 클래스 등록 인원 조회
    retreiveClassUser () {
      // common.axios.get('/class/user/in/' + this.classInfo.class_seq)
      this.loadStoneDataTable('/class/user/in/' + this.classInfo.class_seq, null, false)
        .then(response => {
          this.classUserData = response.data
        })
    },
    goCheckAttendancePage () {
      this.$router.push({name: 'M020106'})
    },
    getChartData (value) {
      const labels = []
      const datasets1 = []
      // const datasets2 = []
      const dataColor = []
      value.map(x => {
        labels.push(`${x.tmp_date}(${x.tmp_day_name})`)
        datasets1.push(x.attend_rate)
        // datasets2.push(0)
        if (x.tmp_today_yn === 'Y') {
          dataColor.push('#b874d3')
        } else {
          dataColor.push('#61618a')
        }
      })
      const datasets = [
        {
          label: '출석률',
          backgroundColor: dataColor,
          data: datasets1
        }
        // {
        //   label: '',
        //   backgroundColor: '#292955',
        //   data: datasets2
        // }
      ]
      return {labels: labels, datasets: datasets}
    },
    handleSelectionToggle (ref, isToggle) {
      if (ref === 'classUserLeftTable') {
        this.handleTableSelectionToggleAll(ref, this.classUserLeftData, isToggle)
      } else {
        this.handleTableSelectionToggleAll(ref, this.classUserRightData, isToggle)
      }
    },
    modifyClass () {
      this.$router.push({name: 'M020102', params: {class_seq: this.classInfo.class_seq, return_page: 'M020103'}})
    },
    deleteClass () {
      this.$confirm('해당 클래스를 삭제하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/class', {data: {class_seq: this.classInfo.class_seq}})
          .then(response => {
            if (response.data.status === 1) {
              this.$message('삭제되었습니다.')
              setTimeout(() => {
                this.$router.push({name: 'M020101'})
              }, 1000)
            } else {
              this.$message.warning(response.data.message)
            }
          })
          .catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    },
    classUserLefteRowClickHandler (row) {
      this.handleTableSelectionToggle('classUserLeftTable', row)
    },
    classUserRighteRowClickHandler (row) {
      this.handleTableSelectionToggle('classUserRightTable', row)
    },
    diallogClosedHandler () {
      this.dialogTableVisible = false
      this.classUserLeftFilters[0].value = ''
      this.classUserRightFilters[0].value = ''
    },
    goSettingAttendPage () {
      this.$router.push({name: 'M020105'})
    }
  },
  watch: {
    isUse: function (value) {
      this.classInfo.use_yn = value ? 'Y' : 'N'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .user-filter {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M020103.vue